/**
 * Fixed-top banner that shows while the browser reports offline. LLM
 * provider calls fall back to offline GTO regardless of which
 * provider is selected — spec §4.10 L325. Banner is purely
 * informational; the fallback is handled by the AI module when the
 * fetch fails.
 */
import { useOnline } from '@/hooks/useOnline';

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      className="fixed top-0 inset-x-0 z-50 bg-warning text-bg text-[11px] font-semibold py-1 text-center"
      role="status"
      data-testid="offline-banner"
    >
      오프라인 — LLM 모드 비활성화 · 오프라인 GTO로 진행
    </div>
  );
}
